import WaitlistAddedIcon from './WaitlistAddedIcon';

export default WaitlistAddedIcon;
